import React from 'react'
import LetterAvatar from './LetterAvatar'

const LetterAvatarDemo = () => {
    return (
        <div className="col-xxl-6">
            <div className="card p-0 overflow-hidden position-relative radius-12">
                <div className="card-header py-16 px-24 bg-base border border-end-0 border-start-0 border-top-0">
                    <h6 className="text-lg mb-0">Letter Avatars</h6>
                </div>
                <div className="card-body p-24">
                    <div className="d-flex align-items-center flex-wrap gap-3">
                        <LetterAvatar letter="A" size="24px" />
                        <LetterAvatar letter="B" size="32px" />
                        <LetterAvatar letter="C" size="40px" />
                        <LetterAvatar letter="D" size="44px" />
                        <LetterAvatar letter="E" size="56px" />
                        <LetterAvatar letter="F" size="64px" />
                        <LetterAvatar letter="G" size="72px" />
                        <LetterAvatar letter="H" size="80px" />
                    </div>

                    <div className="d-flex align-items-center flex-wrap gap-3 mt-24">
                        <LetterAvatar letter="J" size="24px" bgColor="bg-success-500" />
                        <LetterAvatar letter="K" size="32px" bgColor="bg-warning-500" />
                        <LetterAvatar letter="L" size="40px" bgColor="bg-danger-500" />
                        <LetterAvatar letter="M" size="44px" bgColor="bg-info-500" />
                        <LetterAvatar letter="N" size="56px" bgColor="bg-lilac-500" />
                        <LetterAvatar letter="O" size="64px" bgColor="bg-cyan-500" />
                        <LetterAvatar letter="P" size="72px" bgColor="bg-purple-500" />
                        <LetterAvatar letter="Q" size="80px" bgColor="bg-primary-500" />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default LetterAvatarDemo 